import { useState } from "react";
import NewBrandKitCreationModal from "./new-brand-kit-creation-modal";
import Avatar from "../../../../components/avatar";

export default function BrandKitSwitcher({
  brandKits,
  selectedBrandKit,
  setSelectedBrandKit,
}) {
  const [showBrandKitSwitcher, setShowBrandKitSwitcher] = useState(false);
  const [showNewBrandKitCreationModal, setShowNewBrandKitCreationModal] =
    useState(false);

  return (
    <>
      {brandKits.length > 0 && (
        <>
          <div
            role="button"
            onClick={() => setShowBrandKitSwitcher(!showBrandKitSwitcher)}
          >
            <div className="relative flex justify-between items-center gap-2 py-3 px-4 rounded-xl border border-gray-300 bg-gray-50">
              {selectedBrandKit?.logo && (
                <div className="bg-gray-200 w-5 h-5 aspect-square rounded-md overflow-hidden">
                  <img
                    src={selectedBrandKit?.logo}
                    alt=""
                    className="w-full h-full object-cover object-center"
                  />
                </div>
              )}

              {!selectedBrandKit && (
                <p className="w-full text-base font-medium text-start">
                  Select brand kit
                </p>
              )}
              {selectedBrandKit && (
                <p className="w-full text-base font-semibold text-start">
                  {selectedBrandKit?.name}
                </p>
              )}

              <svg
                width="10"
                height="18"
                viewBox="0 0 10 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.41325 12.0867C9.50065 12.1738 9.56999 12.2773 9.61731 12.3913C9.66463 12.5052 9.68899 12.6274 9.68899 12.7508C9.68899 12.8742 9.66463 12.9963 9.61731 13.1103C9.56999 13.2243 9.50065 13.3278 9.41325 13.4148L5.66325 17.1648C5.57615 17.2522 5.47266 17.3216 5.3587 17.3689C5.24475 17.4162 5.12257 17.4406 4.99918 17.4406C4.8758 17.4406 4.75362 17.4162 4.63967 17.3689C4.52571 17.3216 4.42222 17.2522 4.33512 17.1648L0.585122 13.4148C0.409002 13.2387 0.310059 12.9999 0.310059 12.7508C0.310059 12.5017 0.409002 12.2628 0.585122 12.0867C0.761242 11.9106 1.00011 11.8117 1.24918 11.8117C1.49826 11.8117 1.73713 11.9106 1.91325 12.0867L4.99997 15.1719L8.08668 12.0844C8.17391 11.9974 8.27742 11.9284 8.39132 11.8814C8.50521 11.8344 8.62725 11.8104 8.75045 11.8106C8.87365 11.8108 8.9956 11.8353 9.10933 11.8827C9.22306 11.9301 9.32633 11.9994 9.41325 12.0867ZM1.91325 5.91485L4.99997 2.82813L8.08668 5.91563C8.2628 6.09175 8.50167 6.19069 8.75075 6.19069C8.99982 6.19069 9.23869 6.09175 9.41481 5.91563C9.59093 5.73951 9.68987 5.50064 9.68987 5.25157C9.68987 5.0025 9.59093 4.76363 9.41481 4.58751L5.66481 0.837507C5.57771 0.750107 5.47422 0.68076 5.36026 0.633442C5.24631 0.586125 5.12414 0.561768 5.00075 0.561768C4.87736 0.561768 4.75518 0.586125 4.64123 0.633442C4.52728 0.68076 4.42378 0.750107 4.33669 0.837507L0.586685 4.58751C0.410565 4.76363 0.311621 5.0025 0.311621 5.25157C0.311621 5.50064 0.410565 5.73951 0.586685 5.91563C0.762805 6.09175 1.00168 6.19069 1.25075 6.19069C1.49982 6.19069 1.73869 6.09175 1.91481 5.91563L1.91325 5.91485Z"
                  fill="#98A2B3"
                />
              </svg>

              {showBrandKitSwitcher && (
                <div className="w-full absolute right-0 top-[115%] z-10">
                  <div className="w-full overflow-hidden z-200 bg-white divide-y divide-gray-200 shadow-xl rounded-xl ring-1 ring-gray-200 ring-inset">
                    {brandKits.length > 0 && (
                      <div className="p-2">
                        {brandKits.map((brandKit, idx) => (
                          <button
                            key={idx}
                            className="w-full flex items-center justify-between gap-2 px-3 py-2 transition-all duration-150 rounded-lg cursor-pointer hover:bg-gray-100"
                            onClick={() => setSelectedBrandKit(brandKit)}
                          >
                            <Avatar
                              url={brandKit.logo}
                              imageStyle="object-cover w-10 h-10 bg-gray-200 rounded-full shrink-0"
                            />
                            <div>
                              <p className="text-sm font-medium text-gray-900">
                                {brandKit.name}
                              </p>
                            </div>
                            <div className="ml-auto shrink-0">
                              {brandKit?.id === selectedBrandKit?.id && (
                                <svg
                                  aria-hidden="true"
                                  className="w-5 h-5 text-blue-500"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              )}
                            </div>
                          </button>
                        ))}
                      </div>
                    )}

                    <div>
                      <button
                        type="button"
                        onClick={() => setShowNewBrandKitCreationModal(true)}
                        className="flex items-center justify-center w-full gap-2 px-6 py-3 text-sm font-semibold text-blue-500 transition-all duration-150 hover:text-blue-600 bg-gray-50 hover:bg-blue-50"
                      >
                        <svg
                          aria-hidden="true"
                          className="w-5 h-5"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
                            clipRule="evenodd"
                          />
                        </svg>
                        Create Brand Kit
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}

      {showNewBrandKitCreationModal && (
        <NewBrandKitCreationModal
          onClose={() => setShowNewBrandKitCreationModal(false)}
        />
      )}
    </>
  );
}
